<template>
<Table :sendFlag="1" TableName="TABLE_DELIVERY_INFO" permissionName="DELIVERY_INFO"/>
</template>

<script lang='ts'>

import { defineComponent } from 'vue'
import Table from '../components/Table.vue'

export default defineComponent({
  name: 'Delivery',
  components: {
    Table
  }

})
</script>
